import {
  CONCEPT_LOAD,
  CONCEPT_LOAD_SUCCESS,
  CONCEPT_ERROR,
  CONCEPT_SAVE,
  CONCEPT_SAVE_SUCCESS,
  CONCEPT_CLEAN,
  CONCEPT_DELETE,
  CONCEPT_DELETE_SUCCESS
} from "./actionTypes"

const initialState = {
  error: "",
  concepts: [],
  conceptsDelete: [],
  current: null,
  loading: false,
  success: false,
  loadingSave: false,
}

const concept = (state = initialState, action) => {
  switch (action.type) {
    case CONCEPT_LOAD:
      state = {
        ...state,
        concepts: [],
        loading: true,
        success: false,
        current: null,
      }
      break
    case CONCEPT_LOAD_SUCCESS:
      state = {
        ...state,
        loading: false,
        success: true,
        error: "",
        concepts: action.payload,
      }
      break
    case CONCEPT_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
        loadingSave: false,
      }
      break
    case CONCEPT_SAVE:
      state = {
        ...state,
        loadingSave: true,
        success: false,
        current: null,
      }
      break
    case CONCEPT_SAVE_SUCCESS:
      state = {
        ...state,
        loadingSave: false,
        success: true,
        error: "",
        current: action.payload,
      }
      break
    case CONCEPT_CLEAN:
      state = {
        ...state,
        current: null,
        loading: false,
        loadingSave: false,
        success: false,
        error: "",
      }
      break
    case CONCEPT_DELETE:
      state = {
        ...state,
        loading: true,
        success: false,
        conceptsDelete: [],
      }
      break
    case CONCEPT_DELETE_SUCCESS:
      state = {
        ...state,
        loading: true,
        success: true,
        error: "",
        conceptsDelete: action.payload,
      }
      break
  }
  return state
}

export default concept
